import React from 'react';

import { Divider, Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';

import IntlMessages from 'util/IntlMessages';

import ReportTable from '../../ReportTable';
import styles from '../../styles.module.less';
import EmptyUserData from '../shared/EmptyUserData';

export default function IncidentsReport({
  data,
  loading = false,
  next = null,
  queriedPeriod = '',
}) {
  if (data?.data?.length === 0 || Object.keys(data).length === 0) return null;
  const dataKeys = Object.keys(data?.data);
  const cleanData = data?.data[dataKeys[0]];

  return (
    <>
      <div className="gx-w-100">
        <div className={styles.titleDt}>
          <IntlMessages id="work.direction.issues.report" />
        </div>
      </div>
      <Divider />
      {loading && <Spin />}
      <div id="scrollableDiv" className={styles.scrollableDivOwnReports}>
        <InfiniteScroll
          dataLength={data?.total ?? 0}
          scrollableTarget="scrollableDiv"
          next={next}
          hasMore={data?.hasMore}
        >
          <div className="gx-pt-4">
            {Object.keys(data?.data || {})?.length === 0 && !loading && (
              <EmptyUserData queriedPeriod={queriedPeriod} />
            )}
            <ReportTable
              rowKey="id"
              data={cleanData?.source}
              headerOne={cleanData?.employee}
              headerTwo={cleanData?.employer}
              columns={cleanData?.columns}
              disableScroll={true}
            />
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}
